import type { LlmModel } from '@saaga/shared/interfaces/llm-model.interface'
import type { ReactNode } from 'react'
import { useMemo } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import { ModelInfoDisplay } from '@/components/molecules/model-info-display.molecule'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Slider } from '@/components/ui/slider'

import type { AgentNodeFormSchemaType } from '../agency-node-form.schema'

interface AgentNodeModelSectionProps {
  form: UseFormReturn<AgentNodeFormSchemaType>
  modelList: LlmModel[]
}

export const AgentNodeModelSection = ({
  form,
  modelList,
}: AgentNodeModelSectionProps): ReactNode => {
  const selectedModelValue = form.watch('model')
  const selectedModel = useMemo(
    () => modelList.find((model) => model.id === selectedModelValue),
    [modelList, selectedModelValue]
  )

  return (
    <>
      <ModelInfoDisplay model={selectedModel} />
      <FormField
        control={form.control}
        name="temperature"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Temperature: {field.value.toFixed(2)}</FormLabel>
            <FormControl>
              <Slider
                min={0}
                max={1}
                step={0.05}
                value={[field.value]}
                onValueChange={(valueList) => field.onChange(valueList[0])}
                className="agent-node-temperature-slider"
              />
            </FormControl>
            <FormDescription>
              Lower values make output more focused, higher values more creative
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  )
}

AgentNodeModelSection.displayName = 'AgentNodeModelSection'
